import React, { useEffect, useState } from 'react';
import { Row, Col, Popover, OverlayTrigger } from "react-bootstrap";
import { NotificationManager } from 'react-notifications';

import { Fecha, formatBytes, StatusEmail } from '../../funciones/EmailFunction';

import CustomModal from "../../components/Modal/CustomModal";

const MailList = (props) => {
    const [boton1, setBoton1] = useState({ icon: "fa fa-ellipsis-v text-muted", disabled: false });
    const [valores, setValores] = useState (props.opciones)
    const [control, setControl] = useState(false);
    const [openModalConfirm, setOpenModalConfirm] = useState(false);
    const [estilos, setEstilos] = useState({
        colorSobre: "f6a72f",
        claseTexto: "text-primary",
        claseAsunto: "",
        claseTam: "text-danger",
        puntero: "pointer",
        title: "",
        disabled: false,
    })

    const styles2 = {
        padding: 10, fontSize: 13, cursor: estilos.puntero
    }

    const styles3 = {
        padding: 10, fontSize: 11, cursor: estilos.puntero
    }

    let title = (mess) => {
        if (mess === "") return "(sin asunto)"
        return mess
    }

    let adjunto = (adj) => {
        if (adj.length > 0) return (<strong className={estilos.claseTam} style={{fontSize: 18}} title="Con archivo adjunto"><i className="fa fa-paperclip"></i></strong>)
    }

    let resaltar = (status) => {
        if (status === 0) return "bold"
        return null
    }

    let envelope = (status) => {
        if (status === 0) return "fa fa-envelope"
        return "fa fa-envelope-open-o"
    }

    let remitente = (rem, status) => {
        let partes = rem.split("<");

        if (partes[1] === undefined) {
            return (<div style={{fontSize: 11}}><strong>{(partes[0]).replace(/[_]/gi, " ")}</strong></div>)
        }

        return (
            <React.Fragment>
                <div style={{fontSize: 11, fontWeight: resaltar(status)}} className={estilos.claseTexto}>{(partes[0]).replace(/[_]/gi, " ")}</div>
                <div style={{fontSize: 10}} className="text-muted">{`<${partes[1]}`}</div>
            </React.Fragment>
        )
    }

    let deshabMess = (tipo, title) => {
        if (tipo === true) {
            setEstilos({
                colorSobre: "9A9A9A",
                claseTexto: "text-muted",
                claseAsunto: "text-muted",
                claseTam: "text-muted",
                puntero: "not-allowed",
                title: title,
                disabled: true,
            })
        }else{
            setEstilos({
                colorSobre: "f6a72f",
                claseTexto: "text-primary",
                claseAsunto: "",
                claseTam: "text-danger",
                puntero: "pointer",
                title: title,
                disabled: false,
            })
        }
    }

    let noLeido = () => {
        setBoton1({ icon: "fa fa-spinner fa-spin text-muted", disabled: true });
        deshabMess(true, "Espera")
        StatusEmail (props.email.value, valores.UId, "UnSeen", (resp) => {
            let contenido = valores;
            setBoton1({ icon: "fa fa-ellipsis-v text-muted", disabled: false });
            
            if (resp.tipo === "info"){
                contenido.Seen = 0;
                props.funcion2()
                deshabMess(false, "")
                setValores(contenido)
                setControl(!control)
            }else{
                NotificationManager.error(resp.text);
                deshabMess(false, "")
            }
        })
    }

    let Leido = () => {
        setBoton1({ icon: "fa fa-spinner fa-spin text-muted", disabled: true });
        deshabMess(true, "Espera")
        StatusEmail (props.email.value, valores.UId, "Seen", (resp) => {
            let contenido = valores;
            setBoton1({ icon: "fa fa-ellipsis-v text-muted", disabled: false });
            
            if (resp.tipo === "info"){
                contenido.Seen = 1;
                props.funcion2()
                deshabMess(false, "")
                setValores(contenido)
                setControl(!control)
            }else{
                NotificationManager.error(resp.text);
                deshabMess(false, "")
            }
        })
    }

    let Delete = () => {
        setOpenModalConfirm(false, "Este mensaje fue eliminado")
        setBoton1({ icon: "fa fa-spinner fa-spin text-muted", disabled: true });
        deshabMess(true, "")
        StatusEmail (props.email.value, valores.UId, "Delete", (resp) => {
            setBoton1({ icon: "fa fa-ellipsis-v text-muted", disabled: false });
            
            if (resp.tipo === "info"){
                props.funcion2()
                NotificationManager.info("Mensaje Eliminado");
                setControl(!control)
            }else{
                NotificationManager.error(resp.text);
                deshabMess(false, "")
            }
        })
    }

    let toSpam = () => {
        setBoton1({ icon: "fa fa-spinner fa-spin text-muted", disabled: true });
        deshabMess(true, "Espera")
        StatusEmail (props.email.value, valores.UId, "Spam", (resp) => {
            setBoton1({ icon: "fa fa-ellipsis-v text-muted", disabled: false });
            
            if (resp.tipo === "info"){
                props.funcion2()
                deshabMess(true, "")
                setControl(!control)
            }else{
                NotificationManager.error(resp.text);
                deshabMess(false, "")
            }
        })
    }

    let modalConfirm = () => (
        <CustomModal
            boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
            boton1 = {<React.Fragment><i className="fa fa-check"></i> Si</React.Fragment>}
            large = "medium"
            isopen =  {openModalConfirm}
            titulo = "Confirmación"
            contenido = {<div>¿Deseas <strong>Eliminar</strong> el mensaje de la bandeja?</div>}      
            funcion1 = {() => {
                Delete()
            }}
            funcion2 = {() => {
                setOpenModalConfirm(false)
            }}
        />
    )

    let marcarMess = () => {
        if (valores.Seen == 0) return (
            <div className="new-mail-item text-primary" onClick={Leido} style={{fontSize: 11}}><i title="Marcar como Leido" className="fa fa-envelope-open"></i>Marcar Como Leído</div>
        )
        
        return (
            <div className="new-mail-item text-primary" onClick={noLeido} style={{fontSize: 11}}><i title="Marcar como No Leido" className="fa fa-envelope"></i>Marcar Como No Leído</div>
        )
    }

    let lista = (
        <Popover id="tipos">
            <div className="new-mail-item text-primary" onClick={toSpam} style={{fontSize: 11}}><i title="Mover a la carpera Spam" className="fa fa-ban"></i> Mover a Spam</div>
            <div className="new-mail-item text-primary" onClick={()=>{setOpenModalConfirm(true)}} style={{fontSize: 11}}><i title="Eliminar" className="fa fa-trash"></i> Eliminar</div>
            {marcarMess()}
            {/* <div className="new-mail-item text-primary" style={{fontSize: 11}}><i title="Destacar" className="fa fa-star-o"></i> Destacar</div> */}
        </Popover>
    )

    let botones = () => {
        if (boton1.disabled === true || estilos.disabled === true) return (
            <button className="btn btn-default" style={{borderWidth: 0, padding: "5px 0px 5px 0px"}}><i className={boton1.icon} style={{fontSize: 14}}></i></button>
        )

        return (
            <OverlayTrigger trigger="focus" placement="left" overlay={lista}>
                <button className="btn btn-default" style={{borderWidth: 0, padding: "5px 0px 5px 0px"}}><i className={boton1.icon} style={{fontSize: 14}}></i></button>
            </OverlayTrigger>
        )
    }

    let abrirMess = () => {
        if (boton1.disabled === true || estilos.disabled === true) return null
        props.funcion()
    }

    return (
        <React.Fragment>
            <tr title={estilos.title}>
                <td width="50px" style={styles2} onClick={abrirMess}><i style={{ color: estilos.colorSobre }} className={envelope(valores.Seen)}></i></td>
                <td width="20%" style={styles2} onClick={abrirMess}>{remitente(valores.Sender, valores.Seen)}</td>
                <td width="65%" style={styles3} onClick={abrirMess} title={title((valores.Title).toUpperCase())}>
                    <div style={{fontWeight: resaltar(valores.Seen)}} className={estilos.claseAsunto}>{(title((valores.Title).toUpperCase())).substr(0,55)}</div>
                    <div className={estilos.claseTam} style={{fontSize: 11}}>Tamaño: {formatBytes(valores.Size)}</div>
                </td>
                <td width="50px" style={styles2} onClick={abrirMess}>{adjunto(valores.Attachment)}</td>
                <td width="15%" style={styles2} onClick={abrirMess} align="right"><div className="text-muted" style={{fontSize: 11}}>{Fecha(valores.Date)}</div></td>
                <td width="50px" style={styles2} align="right">
                    {botones()}
                </td>
            </tr>
            {modalConfirm()}
        </React.Fragment>
    )
}

export default MailList;


// WEBPACK FOOTER //
// ./src/views/Email/MailList.jsx